export function isStringNotEmpty(string: string): boolean {
  return string ? true : false
}
